import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Select,
  MenuItem,
  FormControl,
  useMediaQuery,
  useTheme,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  Grid,
  Stack,
  Typography,
  Tooltip,
  IconButton,
  Autocomplete,
  TextField,
} from "@mui/material";
import ApiService from "../../_services/ApiService";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import playlist from "../../img/default-image.png";
import { styled } from "@mui/system";
import NoResults from "../../_helpers/reusablefunctions/NoResults";
import SkeletonCard from "../../_helpers/reusablefunctions/SkeletonCard";
import PlaylistDrawer from "./PlaylistDrawer";
import { useHistory } from "react-router-dom";
import PaginationComponent from "../../_helpers/reusablefunctions/paginationComponent";
import useSnackDispatcher from "../../_helpers/reusablefunctions/snackBarComponent";
import { formSnackbar } from "../../_services/_constants/snackbar.constant";
import SnackbarContainer from "../Snackbar";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import { DragIndicator } from "@mui/icons-material";
import { getGenre } from "../../_services/profile";
import SearchBox from "../../components/reusableComponents/SearchBox";
import GetMoodGenreLanguage from "../../_helpers/reusablefunctions/getMoodGenreLanguage";
import DiscoverableTabs from "../../_helpers/reusablecomponents/discoverableTabs";
import CardComponent from "../../_helpers/reusablecomponents/commonCards";
import { useLocation } from "react-router-dom/";

const discoverTabs = [
  { label: "all", value: ["All Playlist"] },
  { label: "official", value: ["Official Playlist"] },
  { label: "trending", value: ["Trending Playlist"] },
];
export default function Discover() {
  const { successSnack, errorSnack, warningSnack, infoSnack } =
    useSnackDispatcher();
  const history = useHistory();
  const location = useLocation();
  const [playlistData, setPlaylistData] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [activeChip, setActiveChip] = useState(location?.state ? location?.state?.value : "0-0");
  const [activeLabel, setActiveLabel] = useState(location?.state ? location?.state?.label : "all");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [total_count, setTotal_count] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [selectedTab, setSelectedTab] = useState(location?.state ? location?.state?.value : "all");

  function playlistCall(value) {
    let payload =
      value !== "all"
        ? { search: value }
        : { premium_users: "True", limit, offset: page };
    setLoader(true);
    ApiService.get("allPlaylist", payload)
      .then((response) => {
        if (response.status === 200) {
          let arrayData = response.data.results;
          const data = arrayData.sort(function (a, b) {
            return parseInt(a.playlist_order) - parseInt(b.playlist_order);
          });
          setPlaylistData(data);
          setTotal_count(response?.data?.total_count);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoader(false);
      });
  }

  const handleChipClick = (i, label) => {
    setActiveChip(i);
    setActiveLabel(label);
    playlistCall(label);
    history.push(`?tab=${label}`,{value:i, label: label});
  };

  const openDetails = (data) => {
    history.push("/playlist-detail", { playlistData: data });
  };

  const trendingplaylist = (data) => {
    let payload =
      activeLabel !== "trending"
        ? {
            ...(data?.type_official && { type_official: data.type_official }),
            type_trending: "trending",
          }
        : {
            type_trending: "",
          };

    infoSnack(
      activeLabel !== "trending"
        ? formSnackbar.playlist.playlistTrendingAdding
        : formSnackbar.playlist.playlistTrendingRemove
    );
    ApiService.put("createEditPlaylist", payload, { id: data?.playlist_id })
      .then((res) => {
        if (res.status == "200") {
          successSnack(
            activeLabel !== "trending"
              ? formSnackbar.playlist.playlistTrendingAdding
              : formSnackbar.playlist.playlistTrendingRemove
          );
          playlistCall(activeLabel);
        }
      })
      .catch((error) => {
        errorSnack(formSnackbar.errors.errorMsg);
        console.log(error);
      });
  };

  // ----------------- DRAG AND DROP FUNCTION -------------

  function handleOnDragEnd(result) {
    if (!result.destination) return;
    const items = Array.from(playlistData);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setPlaylistData(items);
    const data = items.map((song) => song.playlist_id);
    let dataObj = {
      playlist_ids: data.join(","),
    };
    ApiService.put("playlistTtrendSequence", dataObj)
      .then((res) => {
        if (res.status == "200") {
        }
      })
      .catch((error) => {
        errorSnack(formSnackbar.errors.errorMsg);
        console.log(error);
      });
  }

  // --------------- GENERE SEARCH FUNCTION ---------------

  function getSearchList() {
    ApiService.get("searchPlaylist", {
      search: searchInput,
      limit,
      offset: page,
    })
      .then((response) => {
        if (response.status == "200") {
          setPlaylistData(response?.data?.results);
          setTotal_count(response?.data?.total_count);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    if (searchInput != null && searchInput.length > 0) {
      let delaySearch;
      delaySearch = setTimeout(() => {
        getSearchList();
      }, 1000);
      return () => clearTimeout(delaySearch);
    } else {
      playlistCall(activeLabel);
    }
  }, [page, limit, searchInput]);

  // ----------------Search------------
  const handleSearchInput = (value) => {
    setSearchInput(value);
  };

  return (
    <Box sx={{ padding: "1rem 1rem 3rem 1rem" }}>
      <Box
        alignItems={"center"}
        display={"flex"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
        gap={2}
      >
        <h2 style={{ marginLeft: "10px" }}>Discover-Playlist</h2>
        <Button
          variant="contained"
          className="gn-actionbtn"
          onClick={() => setIsDrawerOpen(true)}
        >
          Create Official Playlist
        </Button>
      </Box>
      <Box mt={2}>
        <DiscoverableTabs
          discoverTabs={discoverTabs}
          activeChip={activeChip}
          activeLabel={activeLabel}
          handleChipClick={handleChipClick}
          selectedTab={selectedTab}
          playlistCall={playlistCall}
          setSelectedTab={setSelectedTab}
          handleSearchInput={handleSearchInput}
        />
        <Grid container spacing={2} alignItems="stretch">
          {loader ? (
            Array.from(new Array(8)).map((_, index) => (
              <Grid key={index} item xs={12} md={4} lg={3}>
                <SkeletonCard />
              </Grid>
            ))
          ) : loader === false && playlistData.length === 0 ? (
            <NoResults />
          ) : activeLabel !== "trending" ? (
            playlistData.map((data, index) => (
              <Grid key={index} item xs={12} md={4} lg={3}>
                <CardComponent
                  data={data}
                  activeLabel={activeLabel}
                  genre={data?.playlist_genre}
                  mood={data?.mood}
                  language={data?.language}
                  name={data?.playlist_name || ""}
                  openDetails={openDetails}
                  trendingplaylist={trendingplaylist}
                  alt={data?.playlist_name}
                  image={
                    data.playlist_cover_image
                      ? process.env.REACT_APP_CREATORURL_MEDIA +
                        "/media/" +
                        data.playlist_cover_image
                      : data?.playlist_cover_image_url
                      ? data?.playlist_cover_image_url
                      : playlist
                  }
                  title={data?.playlist_name}
                  type={data?.type_trending}
                />
              </Grid>
            ))
          ) : (
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId="characters" direction="horizontal">
                {(provided) => (
                  <Grid
                    container
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    {playlistData.map((data, index) => (
                      <Draggable
                        key={index}
                        draggableId={index.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <Grid
                            item
                            xs={12}
                            md={4}
                            lg={3}
                            paddingLeft={3}
                            paddingTop={3}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <CardComponent
                              data={data}
                              activeLabel={activeLabel}
                              genre={data?.playlist_genre}
                              mood={data?.mood}
                              language={data?.language}
                              name={data?.playlist_name || ""}
                              openDetails={openDetails}
                              trendingplaylist={trendingplaylist}
                              alt={data?.playlist_name}
                              image={
                                data.playlist_cover_image
                                  ? process.env.REACT_APP_CREATORURL_MEDIA +
                                    "/media/" +
                                    data.playlist_cover_image
                                  : data?.playlist_cover_image_url
                                  ? data?.playlist_cover_image_url
                                  : playlist
                              }
                              title={data?.playlist_name}
                              type={data?.type_trending}
                              provided
                            />
                          </Grid>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Grid>
                )}
              </Droppable>
            </DragDropContext>
          )}
        </Grid>

        <PlaylistDrawer
          type="create"
          isDrawerOpen={isDrawerOpen}
          setIsDrawerOpen={setIsDrawerOpen}
        />
        <PaginationComponent
          setLimit={setLimit}
          setPage={setPage}
          limit={limit}
          total_count={total_count}
          page={page}
        />
        <SnackbarContainer />
      </Box>
    </Box>
  );
}
